// Can put common controller stuff in here :D
import * as Sentry from "@sentry/browser";

import * as initializers0 from '../initializers/alerts.js'; import * as initializers1 from '../initializers/delay.js'; import * as initializers2 from '../initializers/input_components/datetimepicker.js'; import * as initializers3 from '../initializers/input_components/general_event_toggle.js'; import * as initializers4 from '../initializers/input_components/input_mask.js'; import * as initializers5 from '../initializers/input_components/radio_buttons.js'; import * as initializers6 from '../initializers/input_components/switchery.js'; import * as initializers7 from '../initializers/input_components/tom_select.js'; import * as initializers8 from '../initializers/input_components/tooltips.js'; import * as initializers9 from '../initializers/sweetalert.js'; import * as initializers10 from '../initializers/tooltips.js'; let initializers = [initializers0, initializers1, initializers2, initializers3, initializers4, initializers5, initializers6, initializers7, initializers8, initializers9, initializers10];

let runInitializers = function () {
  if (initializers == undefined) { return };

  initializers.forEach((initializer) => {
    try {
      return initializer.default(this);
    } catch(e) {
      console.error('Initializer error:', e);
    }
  });
};

let Controller = function () {
  this.init = () => {
    try {
      runInitializers.call(this);
      this.call();
    } catch(e) {
      if (gon.env == "development") {
        console.error(e.stack)
      } else {
        Sentry.captureException(e);
      }
    }
  };
};

export default Controller;
